import { ITEM_TYPE_ENUM } from "src/enums/company/financialInformation/financialItem";


export const financialItemTypeDictionary: Record<ITEM_TYPE_ENUM, string> = {
    [ITEM_TYPE_ENUM.ITEM]: 'Item',
    [ITEM_TYPE_ENUM.SUBTITLE]: 'Sub Title',
    [ITEM_TYPE_ENUM.TITLE]: 'Title',
    [ITEM_TYPE_ENUM.TOTAL]: 'Total',
    [ITEM_TYPE_ENUM.SUBTOTAL]: 'Sub Total',
}